module.exports = __webpack_public_path__ + "static/media/progress-success.e0555e13.svg";